import { useEffect, useState } from 'react';

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const CHART_COLORS = {
  green: 'rgba(59, 168, 6, 1)',
  orange: 'rgba(225, 116, 0, 1)',
  red: 'rgba(199, 15, 15, 1)',
};

const CHART_SECTIONS = [
  { key: 'MENTAL_NEURAL_DEVELOPMENT', label: '精神、神経発達' },
  { key: 'UNDERSTANDING_ISSUES', label: '理解' },
  { key: 'EMOTIONAL_BEHAVIORAL', label: '情緒・行動' },
  { key: 'LIFESTYLE', label: '生活習慣' },
  { key: 'MEDIA_SLEEP', label: 'メディア' },
  { key: 'PARENTING', label: '子育て状況' },
  { key: 'FAMILY', label: '家族' },
];

const BarChart = ({ analysisContent, showTicksX = false }) => {
  const options = {
    indexAxis: 'y',
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: 0,
    },
    scales: {
      x: {
        ...(showTicksX ? { display: true } : { display: false }),
        ...(showTicksX ? { grid: { display: false } } : {}),
        ticks: { padding: 0 },
        max: 100,
      },
      y: {
        grid: {
          display: false,
        },
        ticks: {
          crossAlign: 'far',
          font: {
            size: 12,
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  const [dataBarChart, setDataBarChart] = useState(null);

  const calculatePercentage = (answeredNo, totalQuestions) => {
    if (!totalQuestions || totalQuestions === 0) return 0;
    return Math.round((answeredNo / totalQuestions) * 100);
  };

  const getColorByPercentage = (percentage) => {
    if (percentage < 30) return CHART_COLORS.green;
    if (percentage < 70) return CHART_COLORS.orange;
    return CHART_COLORS.red;
  };

  const handleAnalysisContentBarChart = () => {
    if (!analysisContent || analysisContent.length === 0) return;

    const getSection = (sectionKey) => {
      return analysisContent.find((item) => item.section_type === sectionKey);
    };

    const labels = CHART_SECTIONS.map(({ key, label }) => {
      const section = getSection(key);
      const answeredNo = section?.total_no_count || 0;
      const totalQuestions = section?.total_answer_count || 0;
      return [label, `${answeredNo} / ${totalQuestions}問`];
    });

    const data = CHART_SECTIONS.map(({ key }) => {
      const section = getSection(key);
      return calculatePercentage(section?.total_no_count, section?.total_answer_count);
    });

    const colors = data.map((percentage) => getColorByPercentage(percentage));

    setDataBarChart({
      labels,
      datasets: [
        {
          label: 'Dataset',
          data,
          borderColor: colors,
          backgroundColor: colors,
          borderWidth: 2,
          barThickness: 24,
        },
      ],
    });
  };

  useEffect(() => {
    handleAnalysisContentBarChart();
  }, [analysisContent]);

  return (
    <>
      {dataBarChart && (
        <div className="w-full" style={{ minHeight: '359px', height: `${359 + (dataBarChart.labels.length - 7) * 52}px` }}>
          <div className="w-full h-full">
            <Bar data={dataBarChart} options={options} />
          </div>
        </div>
      )}
    </>
  );
};

export default BarChart;
